import { render, staticRenderFns } from "./FieldCurrency.vue?vue&type=template&id=920ca036&scoped=true&"
import script from "./FieldCurrency.vue?vue&type=script&lang=js&"
export * from "./FieldCurrency.vue?vue&type=script&lang=js&"
import style0 from "./FieldCurrency.vue?vue&type=style&index=0&id=920ca036&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920ca036",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('920ca036')) {
      api.createRecord('920ca036', component.options)
    } else {
      api.reload('920ca036', component.options)
    }
    module.hot.accept("./FieldCurrency.vue?vue&type=template&id=920ca036&scoped=true&", function () {
      api.rerender('920ca036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldCurrency.vue"
export default component.exports